/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseWorkPeriod
 */
export interface CaseWorkPeriod {
    /**
     * 
     * @type {string}
     * @memberof CaseWorkPeriod
     */
    id?: string;
    /**
     * 
     * @type {any}
     * @memberof CaseWorkPeriod
     */
    securityCase?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof CaseWorkPeriod
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseWorkPeriod
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof CaseWorkPeriod
     */
    statusAtStart?: CaseWorkPeriodStatusAtStartEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseWorkPeriod
     */
    statusAtEnd?: CaseWorkPeriodStatusAtEndEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseWorkPeriod
     */
    owner?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseWorkPeriod
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CaseWorkPeriod
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseWorkPeriod
     */
    updated?: Date;
    /**
     * 
     * @type {number}
     * @memberof CaseWorkPeriod
     */
    durationSeconds?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CaseWorkPeriod
     */
    active?: boolean;
}


/**
 * @export
 */
export const CaseWorkPeriodStatusAtStartEnum = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Escalated: 'ESCALATED',
    Resolved: 'RESOLVED'
} as const;
export type CaseWorkPeriodStatusAtStartEnum = typeof CaseWorkPeriodStatusAtStartEnum[keyof typeof CaseWorkPeriodStatusAtStartEnum];

/**
 * @export
 */
export const CaseWorkPeriodStatusAtEndEnum = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Escalated: 'ESCALATED',
    Resolved: 'RESOLVED'
} as const;
export type CaseWorkPeriodStatusAtEndEnum = typeof CaseWorkPeriodStatusAtEndEnum[keyof typeof CaseWorkPeriodStatusAtEndEnum];


/**
 * Check if a given object implements the CaseWorkPeriod interface.
 */
export function instanceOfCaseWorkPeriod(value: object): value is CaseWorkPeriod {
    return true;
}

export function CaseWorkPeriodFromJSON(json: any): CaseWorkPeriod {
    return CaseWorkPeriodFromJSONTyped(json, false);
}

export function CaseWorkPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseWorkPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'securityCase': json['securityCase'] == null ? undefined : json['securityCase'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'statusAtStart': json['statusAtStart'] == null ? undefined : json['statusAtStart'],
        'statusAtEnd': json['statusAtEnd'] == null ? undefined : json['statusAtEnd'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'durationSeconds': json['durationSeconds'] == null ? undefined : json['durationSeconds'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function CaseWorkPeriodToJSON(json: any): CaseWorkPeriod {
    return CaseWorkPeriodToJSONTyped(json, false);
}

export function CaseWorkPeriodToJSONTyped(value?: CaseWorkPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'securityCase': value['securityCase'],
        'startTime': value['startTime'] == null ? undefined : ((value['startTime']).toISOString()),
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
        'statusAtStart': value['statusAtStart'],
        'statusAtEnd': value['statusAtEnd'],
        'owner': value['owner'],
        'tenantId': value['tenantId'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'durationSeconds': value['durationSeconds'],
        'active': value['active'],
    };
}

